module.exports = __webpack_public_path__ + "img/nav-menu_refresh-orange.6750e96e.svg";